import api from '@/api/vue-exemplo'

export default {
  state: {
    map: null,
    loading: false,
    municipios: []
  },
  getters: {
    map (state) {
      return state.map
    },
    loading (state) {
      return state.loading
    },
    municipios (state) {
      return state.municipios
    }
  },
  mutations: {
    setMap (state, map) {
      state.map = map
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setMunicipios (state, municipios) {
      state.municipios = municipios
    }
  },
  actions: {
    getMunicipios({ commit }) {
      api.getMunicipios()
        .then(response => {
          commit('setMunicipios', response.data)
        })
    }
  }
}
